export var SlotState;
(function (SlotState) {
    SlotState["DISABLED"] = "DISABLED";
    SlotState["NO_SCHEDULED_ITEMS"] = "NO_SCHEDULED_ITEMS";
    SlotState["SCHEDULED_OPERATION"] = "SCHEDULED_OPERATION";
})(SlotState || (SlotState = {}));
export const colourMap = {
    DISABLED: 'rgb(200, 200, 200)',
    NO_SCHEDULED_ITEMS: 'rgb(219, 68, 55)',
    SCHEDULED_OPERATION: 'rgb(144, 238, 144)',
};
export const getStateForSlot = (programme, scheduler, slot) => {
    const scheduledItemsCount = scheduler.getItemsForSlot(slot).length; //this currently wont count items in scheduled groups
    let state;
    if (programme.enabled) {
        state = scheduledItemsCount === 0 ? SlotState.NO_SCHEDULED_ITEMS : SlotState.SCHEDULED_OPERATION;
        if (!state || !colourMap[state])
            state = SlotState.SCHEDULED_OPERATION;
    }
    else {
        state = SlotState.DISABLED;
    }
    return state;
};
export const getColourForSlot = (programme, scheduler, slot) => {
    const state = getStateForSlot(programme, scheduler, slot);
    return state ? colourMap[state] : 'red';
};
export const getStylesForSlotStates = () => {
    const states = Object.keys(colourMap);
    const styles = [];
    for (let i = 0; i < states.length; i++) {
        const state = states[i];
        const colour = colourMap[state];
        styles.push({
            ['& .' + state]: {
                backgroundColor: `color-mix(in oklab, ${colour}, transparent 65%)`,
                ['&:hover']: {
                    backgroundColor: `color-mix(in oklab, ${colour}, transparent 50%)`,
                },
                ['&.Mui-selected']: {
                    backgroundColor: `color-mix(in oklab, ${colour}, transparent 65%)`,
                    ['&:hover']: {
                        backgroundColor: `color-mix(in oklab, ${colour}, transparent 50%)`,
                    },
                },
            },
        });
    }
    return styles;
};
